import axios from "axios"
import Cookies from "universal-cookie"

const cookies = new Cookies()
const auth_token = cookies.get("auth_token")

const serverAPI = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${auth_token}`,
    Accept: "application/json",
  },
})

serverAPI.get("sanctum/csrf-cookie", {
  withCredentials: true,
})
export { serverAPI }
